enum ESessionErrors {
    SessionExpired = 'SESSION_EXPIRED',
}

export default ESessionErrors
